module.exports = require('./helpers/bundle-url').getBundleURL('jAKT5') + "logo.c51670a8.svg";